function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { twMerge } from "@stereoagency/tailwind-config";
import React, { forwardRef } from "react";
function $IconInput(_param, ref) {
    var icon = _param.icon, className = _param.className, props = _object_without_properties(_param, [
        "icon",
        "className"
    ]);
    return /*#__PURE__*/ React.createElement("span", {
        className: twMerge("grid items-center grid-cols-[auto_1fr] grid-rows-1", className)
    }, /*#__PURE__*/ React.createElement("span", {
        className: twMerge("flex items-center justify-center col-start-1 row-start-1 z-10 pointer-events-none pl-6", "[&>svg]:w-[0.9rem] [&>svg]:h-auto")
    }, icon), /*#__PURE__*/ React.createElement("input", _object_spread({
        ref: ref,
        className: twMerge("transition-all", "col-span-2 row-start-1 col-start-1", "py-5 pl-9 pr-5 rounded-full", "font-body text-body-base text-fg-base", "placeholder:opacity-50", "focus:outline focus:outline-4 focus:outline-fg-base")
    }, props)));
}
var IconInput = /*#__PURE__*/ forwardRef($IconInput);
export default IconInput;

//# sourceMappingURL=IconInput.js.map